import { useTranslator } from "components/Translator"
import { Text } from "components/Text"
import { Tag } from "components/Tag"

export const BoatHeader = ({ boat }) => {
  const translator = useTranslator()

  return (
    <header className="flex flex-col gap-2 lg:flex-row items-start">
      <div className="space-y-2">
        <div className="flex flex-row space-x-2 items-center">
          <Text variant="headline3">
            {boat.brandNormalized} - {boat.modelNormalized}
          </Text>
          <Text variant="body1" className="text-light">
            {boat.factoryYear}
          </Text>
        </div>
        <Text className="italic" aria-label="Nom du bateau">
          {boat.name}
        </Text>
      </div>
      <Tag
        className="lg:ml-auto"
        noTruncate
        color={boat.insured ? "success" : "error"}
        label={
          boat.insuredExpireAt ? (
            <Text variant="caption">
              {translator.trans(
                "account.boat.show.insuredExpireAt",
                {
                  insuredExpireAt: new Date(
                    boat.insuredExpireAt,
                  ).toLocaleDateString(translator.locale),
                },
                "pages",
              )}{" "}
            </Text>
          ) : (
            <Text variant="caption">
              {translator.trans("account.boat.show.notInsured", null, "pages")}
            </Text>
          )
        }
      />
    </header>
  )
}
